import moment from "moment";

const tz = "Europe/Helsinki";

const isWithinDay = (input: moment.MomentInput): boolean => {
    const eventDate = moment(input).tz(tz);
    const currentDate = moment().tz(tz);

    return eventDate.diff(currentDate, "days") === 0;
};

const hasPassed = (input: moment.MomentInput, thresholdMinutes?: number): boolean => {
    const eventDate = moment(input).tz(tz);
    const currentDate = moment().tz(tz);

    return eventDate.diff(currentDate, "minutes") < (thresholdMinutes ?? 0);
};

export { isWithinDay, hasPassed };
